<template>
  <div>
    <!--ReportsList :reports="$store.getters.getReports" :columns="$store.getters.getReportsColumns" /-->
    <ReportsList/>
  </div>
</template>
<script>
import ReportsList from "./../components/reports/ReportList.vue";

export default {
  name: "ReportsView",
  components: {
    ReportsList,
  },
};
</script>

<style>
.btn1 {
  /*display:flex;*/
  left: 0;
  width: calc(100% - 50px);
}
.btn2 {
  /*display:flex;*/
  left: 0;
  width: 50px;
}
.div-50 {
  width: 50%;
}
</style>